// Template library route

import { createFileRoute } from '@tanstack/react-router';

import { TemplatesPage } from '@/features/datahub/templates/TemplatesPage';

export const Route = createFileRoute('/_authenticated/datahub/templates')({
  component: TemplatesPage,
});
